import paths from 'paths'
import { AppManagementArea } from 'paths/link'
import { Navigate, useParams } from 'react-router-dom'

type RedirectParams = {
  /**
   * The area to land on. Provided by the router, which owns the
   * permission-aware default. Required so there is exactly one source of
   * truth for where an app deep-link lands.
   */
  area: AppManagementArea
}

export default function AppManagementRouterRedirect({ area }: RedirectParams) {
  const params = useParams<{
    organizationSlug?: string
    appSlug: string
    userId?: string
  }>()

  return (
    <Navigate
      to={paths.appManagement({
        ...params,
        appSlug: params.appSlug || '',
        tenantId: params.userId,
        area,
      })}
      replace
    />
  )
}
